import { ICustomLookupColumn, ICustomLookupOptions } from '../constants';
import { DEFAULT_SEARCH_SCREEN_DIALOG_STYLE } from './customLookupDefaults.contants';
export const LOOKUP_COLUMNS: ICustomLookupColumn[] = [
    {
        dataField: 'Supplier.Value',
        caption: 'Supplier',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: true,
    },
    {
        dataField: 'Abbrev.Value',
        caption: 'Abbrev',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'SupplierName.Value',
        caption: 'Name',
        allowResizing: true,
        minWidth: 200,
        width: 200,
        fixed: false
    },
    {
        dataField: 'City.Value',
        caption: 'City',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'State.Value',
        caption: 'State',
        allowResizing: true,
        minWidth: 100,
        width: 100,
        fixed: false
    },
    {
        dataField: 'BusinessNumber.Value',
        caption: 'Business Number',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: false
    },
    {
        dataField: 'CompanyNumber.Value',
        caption: 'Company Number',
        allowResizing: true,
        minWidth: 150,
        width: 150,
        fixed: false
    },
];

export const supplierLookupConstants: ICustomLookupOptions = {
    columns: LOOKUP_COLUMNS,
    dialogStyle: DEFAULT_SEARCH_SCREEN_DIALOG_STYLE,
    hideColumnHeaders: false,
    disableGridColumnLines: false,
    dataPrefix: 'Details',
    tabbedLookup: {
        isTabbedLookup: true,
    }
};
